// // import {
// //   Box,
// //   Flex,
// //   IconButton,
// //   Button,
// //   Text,
// //   Input,
// //   useDisclosure,
// //   useToast,
// // } from "@chakra-ui/react";

// // import { FiEdit, FiTrash2, FiSearch, FiX } from "react-icons/fi";

// // import { useEffect, useMemo, useState } from "react";
// // import DataTable from "react-data-table-component";

// // import FormModal from "./FormModal";
// // import { AgendamentoService } from "../../services/agendamento.service";

// // import ContentCard from "../../components/common/ContentCard";
// // import { PageHeader } from "../../components/common/PageHeader";

// // function formatDateTime(value?: string) {
// //   if (!value) return "";

// //   const normalized = String(value).replace("T", " ");

// //   if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(normalized)) {
// //     return `${normalized.slice(8, 10)}/${normalized.slice(5, 7)}/${normalized.slice(0, 4)} ${normalized.slice(11, 16)}`;
// //   }

// //   if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(normalized)) {
// //     return `${normalized.slice(8, 10)}/${normalized.slice(5, 7)}/${normalized.slice(0, 4)} ${normalized.slice(11, 16)}`;
// //   }

// //   return normalized;
// // }

// // export default function ListPage() {
// //   const toast = useToast();
// //   const { isOpen, onOpen, onClose } = useDisclosure();

// //   const [rows, setRows] = useState<any[]>([]);
// //   const [editing, setEditing] = useState<any>(null);
// //   const [loading, setLoading] = useState(false);

// //   const [filters, setFilters] = useState({
// //     paciente: "",
// //     paciente_cpf: "",
// //     profissional: "",
// //     procedimento: "",
// //     data_agendamento: "",
// //     data_criacao: "",
// //     observacao: ""
// //   });

// //   const [openFilter, setOpenFilter] = useState<string | null>(null);

// //   async function load() {
// //     try {
// //       setLoading(true);
// //       const data = await AgendamentoService.findAll();
// //       const normalizedRows = Array.isArray(data)
// //         ? data
// //         : Array.isArray((data as any)?.data)
// //           ? (data as any).data
// //           : [];

// //       setRows(normalizedRows);
// //     } catch {
// //       toast({ title: "Erro ao carregar agendamentos", status: "error" });
// //     } finally {
// //       setLoading(false);
// //     }
// //   }

// //   useEffect(() => {
// //     load();
// //   }, []);

// //   async function handleDelete(id: number) {
// //     if (!confirm("Deseja excluir este agendamento?")) return;

// //     try {
// //       await AgendamentoService.delete(id);
// //       toast({ title: "Agendamento excluído com sucesso", status: "success" });
// //       load();
// //     } catch {
// //       toast({ title: "Erro ao excluir agendamento", status: "error" });
// //     }
// //   }

// //   function renderFilter(field: string, label: string) {
// //     return openFilter === field ? (
// //       <Input
// //         size="sm"
// //         autoFocus
// //         placeholder={`Filtrar ${label}`}
// //         value={(filters as any)[field]}
// //         onChange={(e) => setFilters((prev) => ({ ...prev, [field]: e.target.value }))}
// //         onBlur={() => setOpenFilter(null)}
// //       />
// //     ) : (
// //       <Flex align="center" gap={2}>
// //         <Text fontSize="sm" fontWeight="600">{label}</Text>
// //         <IconButton
// //           aria-label="filtro"
// //           icon={<FiSearch />}
// //           size="xs"
// //           variant="ghost"
// //           onClick={() => setOpenFilter(field)}
// //         />
// //       </Flex>
// //     );
// //   }

// //   const filtered = useMemo(() => {
// //     return rows.filter((item) => {
// //       const check = (field: any, filter: string) =>
// //         String(field ?? "").toLowerCase().includes(filter.toLowerCase());

// //       return (
// //         check(item.paciente_nome, filters.paciente) &&
// //         check(item.paciente_cpf, filters.paciente_cpf) &&
// //         check(item.profissional_nome, filters.profissional) &&
// //         check(item.procedimento_nome, filters.procedimento) &&
// //         check(formatDateTime(item.data_agendamento), filters.data_agendamento) &&
// //         check(formatDateTime(item.created_at), filters.data_criacao) &&
// //         check(item.observacao, filters.observacao)
// //       );
// //     });
// //   }, [rows, filters]);

// //   const columns = [
// //     { name: renderFilter("paciente", "Paciente"), selector: (r: any) => r.paciente_nome, minWidth: "210px", wrap: true },
// //     { name: renderFilter("paciente_cpf", "CPF"), selector: (r: any) => r.paciente_cpf, minWidth: "140px" },
// //     {
// //       name: renderFilter("profissional", "Profissional"),
// //       selector: (r: any) => `${r.profissional_nome || ""}${r.profissional_profissao ? ` - ${r.profissional_profissao}` : ""}`,
// //       minWidth: "220px",
// //       wrap: true
// //     },
// //     { name: renderFilter("procedimento", "Procedimento"), selector: (r: any) => r.procedimento_nome, minWidth: "220px", wrap: true },
// //     {
// //       name: renderFilter("data_agendamento", "Data Agendamento"),
// //       selector: (r: any) => formatDateTime(r.data_agendamento),
// //       minWidth: "170px"
// //     },
// //     {
// //       name: renderFilter("data_criacao", "Data Criação"),
// //       selector: (r: any) => formatDateTime(r.created_at),
// //       minWidth: "160px"
// //     },
// //     { name: renderFilter("observacao", "Observação"), selector: (r: any) => r.observacao, minWidth: "200px", wrap: true },
// //     {
// //       name: "Ações",
// //       width: "140px",
// //       cell: (row: any) => (
// //         <Flex gap={2}>
// //           <IconButton icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
// //           <IconButton icon={<FiTrash2 />} size="sm" colorScheme="red" onClick={() => handleDelete(row.id)} />
// //         </Flex>
// //       ),
// //     },
// //   ];

// //   return (
// //     <Box>
// //       <PageHeader
// //         title="Agendamentos"
// //         onNew={() => {
// //           setEditing(null);
// //           onOpen();
// //         }}
// //         actions={
// //           <Button
// //             leftIcon={<FiX />}
// //             size="sm"
// //             variant="outline"
// //             colorScheme="red"
// //             onClick={() => setFilters({
// //               paciente: "",
// //               paciente_cpf: "",
// //               profissional: "",
// //               procedimento: "",
// //               data_agendamento: "",
// //               data_criacao: "",
// //               observacao: ""
// //             })}
// //           >
// //             Limpar filtros
// //           </Button>
// //         }
// //       />

// //       <ContentCard>
// //         <DataTable
// //           columns={columns}
// //           data={filtered}
// //           pagination
// //           progressPending={loading}
// //           highlightOnHover
// //           responsive
// //           noDataComponent="Nenhum agendamento encontrado"
// //         />
// //       </ContentCard>

// //       <FormModal
// //         isOpen={isOpen}
// //         onClose={onClose}
// //         initialData={editing}
// //         onSave={async (data: any) => {
// //           try {
// //             if (editing) {
// //               await AgendamentoService.update(editing.id, data);
// //               toast({ title: "Agendamento atualizado com sucesso", status: "success" });
// //             } else {
// //               await AgendamentoService.create(data);
// //               toast({ title: "Agendamento criado com sucesso", status: "success" });
// //             }
// //             load();
// //           } catch (error: any) {
// //             toast({
// //               title: error?.response?.data?.error || "Erro ao salvar agendamento",
// //               status: "error"
// //             });
// //           } finally {
// //             onClose();
// //             setEditing(null);
// //           }
// //         }}
// //       />
// //     </Box>
// //   );
// // }



// import {
//     Box,
//     Flex,
//     IconButton,
//     Button,
//     Text,
//     Input,
//     useDisclosure,
//     useToast,
//     SimpleGrid,
//     Stat,
//     StatLabel,
//     StatNumber,
//     Badge,
//     HStack,
// } from "@chakra-ui/react";

// import {
//     FiEdit,
//     FiTrash2,
//     FiSearch,
//     FiX,
//     FiCheckCircle,
//     FiXCircle,
//     FiCalendar,
//     FiClock,
//     FiList,
// } from "react-icons/fi";

// import { useEffect, useMemo, useState } from "react";
// import DataTable from "react-data-table-component";

// import FormModal from "./FormModal";
// import { AgendamentoService } from "../../services/agendamento.service";
// import ContentCard from "../../components/common/ContentCard";
// import { PageHeader } from "../../components/common/PageHeader";

// type StatusAgendamento = "agendado" | "concluido" | "cancelado";

// function normalizeStatus(value: unknown): StatusAgendamento {
//     if (value === "concluido" || value === "cancelado") {
//         return value;
//     }

//     return "agendado";
// }

// function getStatusLabel(status: StatusAgendamento) {
//     switch (status) {
//         case "concluido":
//             return "Concluído";
//         case "cancelado":
//             return "Cancelado";
//         default:
//             return "Agendado";
//     }
// }

// function getStatusColor(status: StatusAgendamento) {
//     switch (status) {
//         case "concluido":
//             return "green";
//         case "cancelado":
//             return "red";
//         default:
//             return "orange";
//     }
// }

// function formatDateTime(value?: string) {
//     if (!value) return "";

//     const normalized = String(value).replace("T", " ");

//     if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(normalized)) {
//         return `${normalized.slice(8, 10)}/${normalized.slice(5, 7)}/${normalized.slice(0, 4)} ${normalized.slice(11, 16)}`;
//     }

//     if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(normalized)) {
//         return `${normalized.slice(8, 10)}/${normalized.slice(5, 7)}/${normalized.slice(0, 4)} ${normalized.slice(11, 16)}`;
//     }

//     return normalized;
// }

// export default function ListPage() {
//     const toast = useToast();
//     const { isOpen, onOpen, onClose } = useDisclosure();

//     const [rows, setRows] = useState<any[]>([]);
//     const [editing, setEditing] = useState<any>(null);
//     const [loading, setLoading] = useState(false);
//     const [updatingStatusId, setUpdatingStatusId] = useState<number | null>(null);

//     const [filters, setFilters] = useState({
//         paciente: "",
//         paciente_cpf: "",
//         profissional: "",
//         procedimento: "",
//         data_agendamento: "",
//         data_criacao: "",
//         observacao: "",
//     });

//     const [openFilter, setOpenFilter] = useState<string | null>(null);

//     async function load() {
//         try {
//             setLoading(true);

//             const data = await AgendamentoService.findAll();

//             const normalizedRows = Array.isArray(data)
//                 ? data
//                 : Array.isArray((data as any)?.data)
//                     ? (data as any).data
//                     : [];

//             setRows(normalizedRows);
//         } catch {
//             toast({
//                 title: "Erro ao carregar agendamentos",
//                 status: "error",
//                 position: "top-right",
//             });
//         } finally {
//             setLoading(false);
//         }
//     }

//     useEffect(() => {
//         load();
//     }, []);

//     async function handleDelete(id: number) {
//         if (!confirm("Deseja excluir este agendamento?")) return;

//         try {
//             await AgendamentoService.delete(id);

//             toast({
//                 title: "Agendamento excluído com sucesso",
//                 status: "success",
//                 position: "top-right",
//             });

//             await load();
//         } catch {
//             toast({
//                 title: "Erro ao excluir agendamento",
//                 status: "error",
//                 position: "top-right",
//             });
//         }
//     }

//     async function handleStatusChange(
//         row: any,
//         status: StatusAgendamento
//     ) {
//         const currentStatus = normalizeStatus(row.status);

//         if (currentStatus === status) return;

//         if (
//             status === "cancelado" &&
//             !confirm("Deseja realmente cancelar este agendamento?")
//         ) {
//             return;
//         }

//         try {
//             setUpdatingStatusId(Number(row.id));

//             await AgendamentoService.updateStatus(Number(row.id), status);

//             toast({
//                 title:
//                     status === "concluido"
//                         ? "Agendamento concluído com sucesso"
//                         : "Agendamento cancelado com sucesso",
//                 status: "success",
//                 position: "top-right",
//             });

//             await load();
//         } catch (error: any) {
//             toast({
//                 title:
//                     error?.response?.data?.error ||
//                     "Não foi possível atualizar o status do agendamento",
//                 status: "error",
//                 position: "top-right",
//             });
//         } finally {
//             setUpdatingStatusId(null);
//         }
//     }

//     function renderFilter(field: string, label: string) {
//         return openFilter === field ? (
//             <Input
//                 size="sm"
//                 autoFocus
//                 placeholder={`Filtrar ${label}`}
//                 value={(filters as any)[field]}
//                 onChange={(event) =>
//                     setFilters((prev) => ({
//                         ...prev,
//                         [field]: event.target.value,
//                     }))
//                 }
//                 onBlur={() => setOpenFilter(null)}
//             />
//         ) : (
//             <Flex align="center" gap={2}>
//                 <Text fontSize="sm" fontWeight="600">
//                     {label}
//                 </Text>

//                 <IconButton
//                     aria-label={`Filtrar ${label}`}
//                     icon={<FiSearch />}
//                     size="xs"
//                     variant="ghost"
//                     onClick={() => setOpenFilter(field)}
//                 />
//             </Flex>
//         );
//     }

//     // Os cards usam todos os registros, independentemente dos filtros da tabela.
//     const totals = useMemo(() => {
//         return rows.reduce(
//             (acc, row) => {
//                 const status = normalizeStatus(row.status);

//                 acc.total += 1;
//                 acc[status] += 1;

//                 return acc;
//             },
//             {
//                 total: 0,
//                 agendado: 0,
//                 concluido: 0,
//                 cancelado: 0,
//             }
//         );
//     }, [rows]);

//     const filtered = useMemo(() => {
//         return rows.filter((item) => {
//             const check = (field: unknown, filter: string) =>
//                 String(field ?? "")
//                     .toLocaleLowerCase("pt-BR")
//                     .includes(filter.toLocaleLowerCase("pt-BR"));

//             return (
//                 check(item.paciente_nome, filters.paciente) &&
//                 check(item.paciente_cpf, filters.paciente_cpf) &&
//                 check(item.profissional_nome, filters.profissional) &&
//                 check(item.procedimento_nome, filters.procedimento) &&
//                 check(
//                     formatDateTime(item.data_agendamento),
//                     filters.data_agendamento
//                 ) &&
//                 check(formatDateTime(item.created_at), filters.data_criacao) &&
//                 check(item.observacao, filters.observacao)
//             );
//         });
//     }, [rows, filters]);

//     //   const columns: any[] = [
//     //     {
//     //       name: renderFilter("paciente", "Paciente"),
//     //       selector: (row: any) => row.paciente_nome || "",
//     //       minWidth: "210px",
//     //       wrap: true,
//     //     },
//     //     {
//     //       name: renderFilter("paciente_cpf", "CPF"),
//     //       selector: (row: any) => row.paciente_cpf || "",
//     //       minWidth: "140px",
//     //     },
//     //     {
//     //       name: renderFilter("profissional", "Profissional"),
//     //       selector: (row: any) =>
//     //         `${row.profissional_nome || ""}${
//     //           row.profissional_profissao
//     //             ? ` - ${row.profissional_profissao}`
//     //             : ""
//     //         }`,
//     //       minWidth: "220px",
//     //       wrap: true,
//     //     },
//     //     {
//     //       name: renderFilter("procedimento", "Procedimento"),
//     //       selector: (row: any) => row.procedimento_nome || "",
//     //       minWidth: "200px",
//     //       wrap: true,
//     //     },
//     //     {
//     //       name: renderFilter("data_agendamento", "Data Agendamento"),
//     //       selector: (row: any) => formatDateTime(row.data_agendamento),
//     //       minWidth: "170px",
//     //     },
//     //     {
//     //       name: renderFilter("data_criacao", "Data Criação"),
//     //       selector: (row: any) => formatDateTime(row.created_at),
//     //       minWidth: "160px",
//     //     },
//     //     {
//     //       name: "Status",
//     //       selector: (row: any) => getStatusLabel(normalizeStatus(row.status)),
//     //       sortable: true,
//     //       minWidth: "130px",
//     //       cell: (row: any) => {
//     //         const status = normalizeStatus(row.status);

//     //         return (
//     //           <Badge
//     //             colorScheme={getStatusColor(status)}
//     //             px={3}
//     //             py={1}
//     //             borderRadius="full"
//     //             fontSize="xs"
//     //           >
//     //             {getStatusLabel(status)}
//     //           </Badge>
//     //         );
//     //       },
//     //     },
//     //     {
//     //       name: renderFilter("observacao", "Observação"),
//     //       selector: (row: any) => row.observacao || "",
//     //       minWidth: "200px",
//     //       wrap: true,
//     //     },
//     //     {
//     //       name: "Ações",
//     //       minWidth: "220px",
//     //       cell: (row: any) => {
//     //         const status = normalizeStatus(row.status);
//     //         const updating = updatingStatusId === Number(row.id);

//     //         return (
//     //           <HStack spacing={1}>
//     //             {status === "agendado" && (
//     //               <>
//     //                 <IconButton
//     //                   aria-label="Concluir agendamento"
//     //                   title="Concluir agendamento"
//     //                   icon={<FiCheckCircle />}
//     //                   size="sm"
//     //                   colorScheme="green"
//     //                   variant="ghost"
//     //                   isLoading={updating}
//     //                   onClick={() =>
//     //                     handleStatusChange(row, "concluido")
//     //                   }
//     //                 />

//     //                 <IconButton
//     //                   aria-label="Cancelar agendamento"
//     //                   title="Cancelar agendamento"
//     //                   icon={<FiXCircle />}
//     //                   size="sm"
//     //                   colorScheme="orange"
//     //                   variant="ghost"
//     //                   isLoading={updating}
//     //                   onClick={() =>
//     //                     handleStatusChange(row, "cancelado")
//     //                   }
//     //                 />
//     //               </>
//     //             )}

//     //             <IconButton
//     //               aria-label="Editar agendamento"
//     //               title="Editar agendamento"
//     //               icon={<FiEdit />}
//     //               size="sm"
//     //               colorScheme="blue"
//     //               variant="ghost"
//     //               onClick={() => {
//     //                 setEditing(row);
//     //                 onOpen();
//     //               }}
//     //             />

//     //             <IconButton
//     //               aria-label="Excluir agendamento"
//     //               title="Excluir agendamento"
//     //               icon={<FiTrash2 />}
//     //               size="sm"
//     //               colorScheme="red"
//     //               variant="ghost"
//     //               onClick={() => handleDelete(row.id)}
//     //             />
//     //           </HStack>
//     //         );
//     //       },
//     //     },
//     //   ];


//     const columns: any[] = [
//         {
//             name: "Ações",
//             minWidth: "220px",
//             cell: (row: any) => {
//                 const status = normalizeStatus(row.status);
//                 const updating = updatingStatusId === Number(row.id);

//                 return (
//                     <HStack spacing={1}>
//                         {status === "agendado" && (
//                             <>
//                                 <IconButton
//                                     aria-label="Concluir agendamento"
//                                     title="Concluir agendamento"
//                                     icon={<FiCheckCircle />}
//                                     size="sm"
//                                     colorScheme="green"
//                                     variant="ghost"
//                                     isLoading={updating}
//                                     onClick={() =>
//                                         handleStatusChange(row, "concluido")
//                                     }
//                                 />

//                                 <IconButton
//                                     aria-label="Cancelar agendamento"
//                                     title="Cancelar agendamento"
//                                     icon={<FiXCircle />}
//                                     size="sm"
//                                     colorScheme="orange"
//                                     variant="ghost"
//                                     isLoading={updating}
//                                     onClick={() =>
//                                         handleStatusChange(row, "cancelado")
//                                     }
//                                 />
//                             </>
//                         )}

//                         <IconButton
//                             aria-label="Editar agendamento"
//                             title="Editar agendamento"
//                             icon={<FiEdit />}
//                             size="sm"
//                             colorScheme="blue"
//                             variant="ghost"
//                             onClick={() => {
//                                 setEditing(row);
//                                 onOpen();
//                             }}
//                         />

//                         <IconButton
//                             aria-label="Excluir agendamento"
//                             title="Excluir agendamento"
//                             icon={<FiTrash2 />}
//                             size="sm"
//                             colorScheme="red"
//                             variant="ghost"
//                             onClick={() => handleDelete(row.id)}
//                         />
//                     </HStack>
//                 );
//             },
//         },
//         {
//             name: renderFilter("paciente", "Paciente"),
//             selector: (row: any) => row.paciente_nome || "",
//             minWidth: "210px",
//             wrap: true,
//         },
//         {
//             name: renderFilter("paciente_cpf", "CPF"),
//             selector: (row: any) => row.paciente_cpf || "",
//             minWidth: "140px",
//         },
//         {
//             name: renderFilter("profissional", "Profissional"),
//             selector: (row: any) =>
//                 `${row.profissional_nome || ""}${row.profissional_profissao
//                     ? ` - ${row.profissional_profissao}`
//                     : ""
//                 }`,
//             minWidth: "220px",
//             wrap: true,
//         },
//         {
//             name: renderFilter("procedimento", "Procedimento"),
//             selector: (row: any) => row.procedimento_nome || "",
//             minWidth: "200px",
//             wrap: true,
//         },
//         {
//             name: renderFilter("data_agendamento", "Data Agendamento"),
//             selector: (row: any) => formatDateTime(row.data_agendamento),
//             minWidth: "170px",
//         },
//         {
//             name: renderFilter("data_criacao", "Data Criação"),
//             selector: (row: any) => formatDateTime(row.created_at),
//             minWidth: "160px",
//         },
//         {
//             name: "Status",
//             selector: (row: any) => getStatusLabel(normalizeStatus(row.status)),
//             sortable: true,
//             minWidth: "130px",
//             cell: (row: any) => {
//                 const status = normalizeStatus(row.status);

//                 return (
//                     <Badge
//                         colorScheme={getStatusColor(status)}
//                         px={3}
//                         py={1}
//                         borderRadius="full"
//                         fontSize="xs"
//                     >
//                         {getStatusLabel(status)}
//                     </Badge>
//                 );
//             },
//         },
//         {
//             name: renderFilter("observacao", "Observação"),
//             selector: (row: any) => row.observacao || "",
//             minWidth: "200px",
//             wrap: true,
//         },
//     ];



//     function clearFilters() {
//         setFilters({
//             paciente: "",
//             paciente_cpf: "",
//             profissional: "",
//             procedimento: "",
//             data_agendamento: "",
//             data_criacao: "",
//             observacao: "",
//         });

//         setOpenFilter(null);
//     }

//     return (
//         <Box>
//             <PageHeader
//                 title="Agendamentos"
//                 onNew={() => {
//                     setEditing(null);
//                     onOpen();
//                 }}
//                 actions={
//                     <Button
//                         leftIcon={<FiX />}
//                         size="sm"
//                         variant="outline"
//                         colorScheme="red"
//                         onClick={clearFilters}
//                     >
//                         Limpar filtros
//                     </Button>
//                 }
//             />

//             <SimpleGrid
//                 columns={{ base: 1, sm: 2, xl: 4 }}
//                 spacing={4}
//                 mb={5}
//             >
//                 <Box
//                     bg="white"
//                     border="1px solid"
//                     borderColor="blue.100"
//                     borderLeft="4px solid"
//                     borderLeftColor="blue.500"
//                     borderRadius="lg"
//                     p={4}
//                     boxShadow="sm"
//                 >
//                     <Stat>
//                         <Flex justify="space-between" align="center">
//                             <StatLabel color="gray.600">Total de agendamentos</StatLabel>
//                             <Box color="blue.500">
//                                 <FiList size={21} />
//                             </Box>
//                         </Flex>
//                         <StatNumber color="blue.700">{totals.total}</StatNumber>
//                     </Stat>
//                 </Box>

//                 <Box
//                     bg="white"
//                     border="1px solid"
//                     borderColor="orange.100"
//                     borderLeft="4px solid"
//                     borderLeftColor="orange.400"
//                     borderRadius="lg"
//                     p={4}
//                     boxShadow="sm"
//                 >
//                     <Stat>
//                         <Flex justify="space-between" align="center">
//                             <StatLabel color="gray.600">Agendados</StatLabel>
//                             <Box color="orange.500">
//                                 <FiCalendar size={21} />
//                             </Box>
//                         </Flex>
//                         <StatNumber color="orange.600">{totals.agendado}</StatNumber>
//                     </Stat>
//                 </Box>

//                 <Box
//                     bg="white"
//                     border="1px solid"
//                     borderColor="green.100"
//                     borderLeft="4px solid"
//                     borderLeftColor="green.500"
//                     borderRadius="lg"
//                     p={4}
//                     boxShadow="sm"
//                 >
//                     <Stat>
//                         <Flex justify="space-between" align="center">
//                             <StatLabel color="gray.600">Concluídos</StatLabel>
//                             <Box color="green.500">
//                                 <FiCheckCircle size={21} />
//                             </Box>
//                         </Flex>
//                         <StatNumber color="green.700">{totals.concluido}</StatNumber>
//                     </Stat>
//                 </Box>

//                 <Box
//                     bg="white"
//                     border="1px solid"
//                     borderColor="red.100"
//                     borderLeft="4px solid"
//                     borderLeftColor="red.500"
//                     borderRadius="lg"
//                     p={4}
//                     boxShadow="sm"
//                 >
//                     <Stat>
//                         <Flex justify="space-between" align="center">
//                             <StatLabel color="gray.600">Cancelados</StatLabel>
//                             <Box color="red.500">
//                                 <FiClock size={21} />
//                             </Box>
//                         </Flex>
//                         <StatNumber color="red.700">{totals.cancelado}</StatNumber>
//                     </Stat>
//                 </Box>
//             </SimpleGrid>

//             <ContentCard>
//                 <DataTable
//                     columns={columns}
//                     data={filtered}
//                     pagination
//                     progressPending={loading}
//                     highlightOnHover
//                     responsive
//                     noDataComponent="Nenhum agendamento encontrado"
//                     paginationPerPage={10}
//                     paginationRowsPerPageOptions={[10, 25, 50, 100]}
//                 />
//             </ContentCard>

//             <FormModal
//                 isOpen={isOpen}
//                 onClose={onClose}
//                 initialData={editing}
//                 onSave={async (data: any) => {
//                     try {
//                         if (editing) {
//                             await AgendamentoService.update(editing.id, data);

//                             toast({
//                                 title: "Agendamento atualizado com sucesso",
//                                 status: "success",
//                             });
//                         } else {
//                             await AgendamentoService.create(data);

//                             toast({
//                                 title: "Agendamento criado com sucesso",
//                                 status: "success",
//                             });
//                         }

//                         await load();
//                         onClose();
//                         setEditing(null);
//                     } catch (error: any) {
//                         toast({
//                             title:
//                                 error?.response?.data?.error ||
//                                 "Erro ao salvar agendamento",
//                             status: "error",
//                         });
//                     }
//                 }}
//             />
//         </Box>
//     );
// }



import {
  Box,
  Flex,
  IconButton,
  Button,
  Text,
  Input,
  useDisclosure,
  useToast,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Badge,
  HStack,
  Tooltip,
} from "@chakra-ui/react";

import {
  FiEdit,
  FiTrash2,
  FiSearch,
  FiX,
  FiCheckCircle,
  FiXCircle,
  FiCalendar,
  FiClock,
  FiList,
} from "react-icons/fi";

import { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";

import FormModal from "./FormModal";
import { AgendamentoService } from "../../services/agendamento.service";
import ContentCard from "../../components/common/ContentCard";
import { PageHeader } from "../../components/common/PageHeader";

type StatusAgendamento = "agendado" | "concluido" | "cancelado";

function normalizeStatus(value: unknown): StatusAgendamento {
  if (value === "concluido" || value === "cancelado") {
    return value;
  }

  return "agendado";
}

function getStatusLabel(status: StatusAgendamento) {
  switch (status) {
    case "concluido":
      return "Concluído";
    case "cancelado":
      return "Cancelado";
    default:
      return "Agendado";
  }
}

function getStatusColor(status: StatusAgendamento) {
  switch (status) {
    case "concluido":
      return "green";
    case "cancelado":
      return "red";
    default:
      return "orange";
  }
}

function formatDateTime(value?: string) {
  if (!value) return "";

  const normalized = String(value).replace("T", " ");

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(normalized)) {
    return `${normalized.slice(8, 10)}/${normalized.slice(5, 7)}/${normalized.slice(0, 4)} ${normalized.slice(11, 16)}`;
  }

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(normalized)) {
    return `${normalized.slice(8, 10)}/${normalized.slice(5, 7)}/${normalized.slice(0, 4)} ${normalized.slice(11, 16)}`;
  }

  return normalized;
}

export default function ListPage() {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [rows, setRows] = useState<any[]>([]);
  const [editing, setEditing] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [updatingStatusId, setUpdatingStatusId] = useState<number | null>(null);

  const [filters, setFilters] = useState({
    paciente: "",
    paciente_cpf: "",
    profissional: "",
    procedimento: "",
    data_agendamento: "",
    data_criacao: "",
    observacao: "",
  });

  const [openFilter, setOpenFilter] = useState<string | null>(null);

  async function load() {
    try {
      setLoading(true);

      const data = await AgendamentoService.findAll();

      const normalizedRows = Array.isArray(data)
        ? data
        : Array.isArray((data as any)?.data)
          ? (data as any).data
          : [];

      setRows(normalizedRows);
    } catch {
      toast({
        title: "Erro ao carregar agendamentos",
        status: "error",
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function handleDelete(id: number) {
    if (!confirm("Deseja excluir este agendamento?")) return;

    try {
      await AgendamentoService.delete(id);

      toast({
        title: "Agendamento excluído com sucesso",
        status: "success",
        position: "top-right",
      });

      await load();
    } catch (error: any) {
      toast({
        title:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Erro ao excluir agendamento",
        status: "error",
        position: "top-right",
      });
    }
  }

  async function handleStatusChange(
    row: any,
    status: StatusAgendamento,
    closeModalAfterUpdate = false
  ) {
    const currentStatus = normalizeStatus(row.status);

    if (currentStatus === status) return;

    if (
      status === "cancelado" &&
      !confirm("Deseja realmente cancelar este agendamento?")
    ) {
      return;
    }

    try {
      setUpdatingStatusId(Number(row.id));

      await AgendamentoService.updateStatus(Number(row.id), status);

      toast({
        title:
          status === "concluido"
            ? "Agendamento concluído com sucesso"
            : "Agendamento cancelado com sucesso",
        status: "success",
        position: "top-right",
      });

      await load();

      if (closeModalAfterUpdate) {
        onClose();
        setEditing(null);
      }
    } catch (error: any) {
      toast({
        title:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Não foi possível atualizar o status do agendamento",
        status: "error",
        position: "top-right",
      });
    } finally {
      setUpdatingStatusId(null);
    }
  }

  function renderFilter(field: string, label: string) {
    return openFilter === field ? (
      <Input
        size="sm"
        autoFocus
        placeholder={`Filtrar ${label}`}
        value={(filters as any)[field]}
        onChange={(event) =>
          setFilters((prev) => ({
            ...prev,
            [field]: event.target.value,
          }))
        }
        onBlur={() => setOpenFilter(null)}
      />
    ) : (
      <Flex align="center" gap={2}>
        <Text fontSize="sm" fontWeight="600">
          {label}
        </Text>

        <IconButton
          aria-label={`Filtrar ${label}`}
          icon={<FiSearch />}
          size="xs"
          variant="ghost"
          onClick={() => setOpenFilter(field)}
        />
      </Flex>
    );
  }

  // Os cards usam todos os registros, independentemente dos filtros da tabela.
  const totals = useMemo(() => {
    return rows.reduce(
      (acc, row) => {
        const status = normalizeStatus(row.status);

        acc.total += 1;
        acc[status] += 1;

        return acc;
      },
      {
        total: 0,
        agendado: 0,
        concluido: 0,
        cancelado: 0,
      }
    );
  }, [rows]);

  const filtered = useMemo(() => {
    return rows.filter((item) => {
      const check = (field: unknown, filter: string) =>
        String(field ?? "")
          .toLocaleLowerCase("pt-BR")
          .includes(filter.toLocaleLowerCase("pt-BR"));

      return (
        check(item.paciente_nome, filters.paciente) &&
        check(item.paciente_cpf, filters.paciente_cpf) &&
        check(item.profissional_nome, filters.profissional) &&
        check(item.procedimento_nome, filters.procedimento) &&
        check(
          formatDateTime(item.data_agendamento),
          filters.data_agendamento
        ) &&
        check(formatDateTime(item.created_at), filters.data_criacao) &&
        check(item.observacao, filters.observacao)
      );
    });
  }, [rows, filters]);

  const columns: any[] = [
    {
      name: "Ações",
      width: "190px",
      ignoreRowClick: true,
      allowOverflow: true,
      cell: (row: any) => {
        const status = normalizeStatus(row.status);
        const updating = updatingStatusId === Number(row.id);

        return (
          <Flex gap={2} align="center">
            {status === "agendado" && (
              <>
                <Tooltip label="Concluir atendimento">
                  <IconButton
                    aria-label="Concluir atendimento"
                    icon={<FiCheckCircle />}
                    size="sm"
                    colorScheme="green"
                    isLoading={updating}
                    isDisabled={updating}
                    onClick={() => handleStatusChange(row, "concluido")}
                  />
                </Tooltip>

                <Tooltip label="Cancelar agendamento">
                  <IconButton
                    aria-label="Cancelar agendamento"
                    icon={<FiXCircle />}
                    size="sm"
                    colorScheme="red"
                    isLoading={updating}
                    isDisabled={updating}
                    onClick={() => handleStatusChange(row, "cancelado")}
                  />
                </Tooltip>
              </>
            )}

            <Tooltip label="Editar agendamento">
              <IconButton
                aria-label="Editar agendamento"
                icon={<FiEdit />}
                size="sm"
                colorScheme="blue"
                isDisabled={updating}
                onClick={() => {
                  setEditing(row);
                  onOpen();
                }}
              />
            </Tooltip>

            <Tooltip label="Excluir agendamento">
              <IconButton
                aria-label="Excluir agendamento"
                icon={<FiTrash2 />}
                size="sm"
                colorScheme="red"
                isDisabled={updating}
                onClick={() => handleDelete(Number(row.id))}
              />
            </Tooltip>
          </Flex>
        );
      },
    },
    {
      name: renderFilter("paciente", "Paciente"),
      selector: (row: any) => row.paciente_nome || "",
      minWidth: "210px",
      wrap: true,
    },
    {
      name: renderFilter("paciente_cpf", "CPF"),
      selector: (row: any) => row.paciente_cpf || "",
      minWidth: "140px",
    },
    {
      name: renderFilter("profissional", "Profissional"),
      selector: (row: any) =>
        `${row.profissional_nome || ""}${
          row.profissional_profissao
            ? ` - ${row.profissional_profissao}`
            : ""
        }`,
      minWidth: "220px",
      wrap: true,
    },
    {
      name: renderFilter("procedimento", "Procedimento"),
      selector: (row: any) => row.procedimento_nome || "",
      minWidth: "200px",
      wrap: true,
    },
    {
      name: renderFilter("data_agendamento", "Data Agendamento"),
      selector: (row: any) => formatDateTime(row.data_agendamento),
      minWidth: "170px",
    },
    {
      name: renderFilter("data_criacao", "Data Criação"),
      selector: (row: any) => formatDateTime(row.created_at),
      minWidth: "160px",
    },
    {
      name: "Status",
      selector: (row: any) => getStatusLabel(normalizeStatus(row.status)),
      sortable: true,
      minWidth: "130px",
      cell: (row: any) => {
        const status = normalizeStatus(row.status);

        return (
          <Badge
            colorScheme={getStatusColor(status)}
            px={3}
            py={1}
            borderRadius="full"
            fontSize="xs"
          >
            {getStatusLabel(status)}
          </Badge>
        );
      },
    },
    {
      name: renderFilter("observacao", "Observação"),
      selector: (row: any) => row.observacao || "",
      minWidth: "200px",
      wrap: true,
    },
  ];

  function clearFilters() {
    setFilters({
      paciente: "",
      paciente_cpf: "",
      profissional: "",
      procedimento: "",
      data_agendamento: "",
      data_criacao: "",
      observacao: "",
    });

    setOpenFilter(null);
  }

  return (
    <Box>
      <PageHeader
        title="Agendamentos"
        onNew={() => {
          setEditing(null);
          onOpen();
        }}
        actions={
          <Button
            leftIcon={<FiX />}
            size="sm"
            variant="outline"
            colorScheme="red"
            onClick={clearFilters}
          >
            Limpar filtros
          </Button>
        }
      />

      <SimpleGrid
        columns={{ base: 1, sm: 2, xl: 4 }}
        spacing={4}
        mb={5}
      >
        <Box
          bg="white"
          border="1px solid"
          borderColor="blue.100"
          borderLeft="4px solid"
          borderLeftColor="blue.500"
          borderRadius="lg"
          p={4}
          boxShadow="sm"
        >
          <Stat>
            <Flex justify="space-between" align="center">
              <StatLabel color="gray.600">Total de agendamentos</StatLabel>
              <Box color="blue.500">
                <FiList size={21} />
              </Box>
            </Flex>
            <StatNumber color="blue.700">{totals.total}</StatNumber>
          </Stat>
        </Box>

        <Box
          bg="white"
          border="1px solid"
          borderColor="orange.100"
          borderLeft="4px solid"
          borderLeftColor="orange.400"
          borderRadius="lg"
          p={4}
          boxShadow="sm"
        >
          <Stat>
            <Flex justify="space-between" align="center">
              <StatLabel color="gray.600">Agendados</StatLabel>
              <Box color="orange.500">
                <FiCalendar size={21} />
              </Box>
            </Flex>
            <StatNumber color="orange.600">{totals.agendado}</StatNumber>
          </Stat>
        </Box>

        <Box
          bg="white"
          border="1px solid"
          borderColor="green.100"
          borderLeft="4px solid"
          borderLeftColor="green.500"
          borderRadius="lg"
          p={4}
          boxShadow="sm"
        >
          <Stat>
            <Flex justify="space-between" align="center">
              <StatLabel color="gray.600">Concluídos</StatLabel>
              <Box color="green.500">
                <FiCheckCircle size={21} />
              </Box>
            </Flex>
            <StatNumber color="green.700">{totals.concluido}</StatNumber>
          </Stat>
        </Box>

        <Box
          bg="white"
          border="1px solid"
          borderColor="red.100"
          borderLeft="4px solid"
          borderLeftColor="red.500"
          borderRadius="lg"
          p={4}
          boxShadow="sm"
        >
          <Stat>
            <Flex justify="space-between" align="center">
              <StatLabel color="gray.600">Cancelados</StatLabel>
              <Box color="red.500">
                <FiClock size={21} />
              </Box>
            </Flex>
            <StatNumber color="red.700">{totals.cancelado}</StatNumber>
          </Stat>
        </Box>
      </SimpleGrid>

      <ContentCard>
        <DataTable
          columns={columns}
          data={filtered}
          pagination
          progressPending={loading}
          highlightOnHover
          responsive
          noDataComponent="Nenhum agendamento encontrado"
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 50, 100]}
        />
      </ContentCard>

      <FormModal
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setEditing(null);
        }}
        initialData={editing}
        statusUpdating={
          editing ? updatingStatusId === Number(editing.id) : false
        }
        onStatusChange={async (status) => {
          if (!editing) return;

          await handleStatusChange(editing, status, true);
        }}
        onSave={async (data: any) => {
          try {
            if (editing) {
              await AgendamentoService.update(editing.id, data);

              toast({
                title: "Agendamento atualizado com sucesso",
                status: "success",
                position: "top-right",
              });
            } else {
              await AgendamentoService.create(data);

              toast({
                title: "Agendamento criado com sucesso",
                status: "success",
                position: "top-right",
              });
            }

            await load();
            onClose();
            setEditing(null);
          } catch (error: any) {
            toast({
              title:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "Erro ao salvar agendamento",
              status: "error",
              position: "top-right",
            });
          }
        }}
      />
    </Box>
  );
}
